export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1548018560-4cb48a8837c1?q=80&w=2200&auto=format&fit=crop",
  missionImg: "https://images.unsplash.com/photo-1578575437130-527eed3abbec?q=80&w=1600&auto=format&fit=crop",
  visionImg: "/ponte6-night.jpg",
  venice:
    "https://images.unsplash.com/photo-1552751118-d3cde54807de?q=80&w=1400&auto=format&fit=crop",
  casablanca:
    "https://images.unsplash.com/photo-1713967600960-877e5512a130?q=80&w=1400&auto=format&fit=crop",
  zellige:
    "https://images.unsplash.com/photo-1517574012247-6941b83050d5?q=80&w=1400&auto=format&fit=crop",
  arch:
    "https://images.unsplash.com/photo-1517574394752-94986fc2c084?q=80&w=1400&auto=format&fit=crop",
  milan:
    "https://images.unsplash.com/photo-1742148186848-8b257455009b?q=80&w=1600&auto=format&fit=crop",
  casaBiz:
    "https://images.unsplash.com/photo-1732383309679-b00fd4269d07?q=80&w=1600&auto=format&fit=crop",
  casaAerial:
    "https://images.unsplash.com/photo-1693532088390-d278b7cefed0?q=80&w=1600&auto=format&fit=crop",
  bridgeLight:
    "https://images.unsplash.com/photo-1781116309304-98fde4a6430f?q=80&w=2000&auto=format&fit=crop",
};
